import { apiClient, unwrap } from '@/lib/apiClient';
import type { LeaveRequestForm } from '@/lib/leaveRequest.schema';
import type { ApiSuccess } from '@/types/api';
import type { StudentLeaveRequest } from '@/types/leave';

/**
 * The child's own leave requests.
 *
 * The parent panel's three calls with no child in the path — the server reads
 * which child from the token, so there is no id here to point at another's.
 */
export const studentLeaveApi = {
  /** Every request filed for them, by them or their family, newest first. */
  list: () => unwrap(apiClient.get<ApiSuccess<StudentLeaveRequest[]>>('/student/leave-requests')),

  /** Files a new one. It lands in their class teacher's queue. */
  request: (payload: LeaveRequestForm) =>
    unwrap(apiClient.post<ApiSuccess<StudentLeaveRequest>>('/student/leave-requests', payload)),

  /** Withdraws one the class teacher has not answered yet. */
  cancel: (requestUuid: string) =>
    unwrap(
      apiClient.delete<ApiSuccess<StudentLeaveRequest>>(`/student/leave-requests/${requestUuid}`),
    ),
};
